import { h } from '@stencil/core';

import { IcoDynamicContentLoader } from './IcoDynamicContentLoader';

export const IcoVehicleConditionsLoader = (props) => {
  const classes = {
    visible: true,
    'font-ico-body': true,
    'py-2': true,
  };

  const prefix = 'vehicle';
  const separator = '-';

  return <IcoDynamicContentLoader classes={classes} prefix={prefix} separator={separator} {...props} />;
};
